import moment from "moment/moment";

const riskAlertReport = (riskAlert) => {
  return {
    date: moment(riskAlert.observationDate).format('MMM D, YYYY'),
    formName: riskAlert.report.form.name,
    type: riskAlert.report.form.type,
    guid: riskAlert.report.reportGuid,
    getFullNameFor(key = 'oit') { //oit only
      // if(key !== 'oit') {
      //   throw new Error('only oit supported for getFullNameFor')
      // }

      if(riskAlert[key]) {
        const first = riskAlert[key].firstName;
        const last = riskAlert[key].lastName;
        return `${first} ${last}`;
      } else if(riskAlert[`${key}FirstName`]) {
        const first = riskAlert[`${key}FirstName`];
        const last = riskAlert[`${key}LastName`];
        return `${first} ${last}`;
      } else {
        const first = riskAlert.oit.firstName;
        const last = riskAlert.oit.lastName;
        return `${first} ${last}`;
      }

    },
  }
};

export default riskAlertReport;